export const formatName = (
  firstName: string,
  lastName: string
): string | null => {
  return firstName || lastName ? `${firstName || ""} ${lastName || ""}` : null;
};
